import { Component, Input, LOCALE_ID, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";
import { CommentsStoreService } from "../../../_shared/services/comments-store.service";
import { AlertService, IAlertType } from "../../../_shared/services";
import {CombinedCommentDetail, KommentarList} from "../../../_shared/interfaces";
import moment from "moment/moment";

import { DatePipe, JsonPipe, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { TranslocoDirective } from "@jsverse/transloco";
import { ClarityIcons, exclamationCircleIcon, exclamationTriangleIcon } from "@cds/core/icon";

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-comment-overview',
  standalone: true,
  imports: [
    ClrDatagridModule,
    ClrIconModule,
    TranslocoDirective,
    DatePipe,
    JsonPipe,
    NgIf,
    RouterLink
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'de' }],
  templateUrl: './comment-overview.component.html',
  styleUrl: './comment-overview.component.sass'
})
export class CommentOverviewComponent implements OnInit {
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  devMode: boolean = false;
  combinedComments: CombinedCommentDetail[] = [];
  commentsData: KommentarList[] = [];

  @Input() commentType: number = 0;
  @Input() companyId: number = 0;
  @Input() projectId: string = '';
  @Input() subId: number = 0;
  @Input() staffId: number = 0;
  @Input() future: boolean = false;
  @Input() status: boolean = false;

  constructor(
    private commentss: CommentsStoreService,
    private alertDispatcher: AlertService,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(exclamationCircleIcon, exclamationTriangleIcon);
  }

  ngOnInit(): void {
    this.reloadComments();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['commentType'] ||
      changes['projectId'] ||
      changes['subId'] ||
      changes['staffId'] ||
      changes['future'] ||
      changes['status']
    ) {
      this.reloadComments();
    }
  }

  private reloadComments() {
    this.loading = true;
    this.loadComments(this.commentType, this.projectId, this.subId, this.future, this.status, this.staffId);
    if (this.devMode) {
      console.log('Project:', this.projectId, 'subId:', this.subId, 'commentType:', this.commentType);
    }
  }

  loadComments(commentID: number, projectId: string, subId: number, future: boolean, done: boolean, staffId: number = 0) {
    this.combinedComments = [];
    this.commentss.getComments(commentID, projectId, subId, done, staffId).subscribe({
      next: commentsData => {
        if (!commentsData || !commentsData.object || commentsData.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Kommentare gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        this.combinedComments = commentsData.object;
        this.descSort = ClrDatagridSortOrder.ASC;
      },
      complete: () => {
        if (future) {
          if (this.combinedComments) this.combinedComments = this.combinedComments.filter(t => (t.remember !== null) && (this.dateDiff(t.remember) < -5));
        } else {
          if (this.combinedComments) this.combinedComments = this.combinedComments.filter(t => !t.remember || (this.dateDiff(t.remember) > -5));
        }

        this.loading = false;
      },
      error: () => {
        return
      }
    })
  }

  dateDiff(remember: string) {
    moment.locale('de');
    var today = new Date();
    let firstDate = moment(today);
    let secondDate = moment(remember);
    return firstDate.diff(secondDate, 'days');
  }

  validDateFormat(dateString: string) {
    if(dateString) {
      return dateString.replace(/\s/, 'T');
    }
    return null;
  }

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }

  findButtonClass(remember: string) {
    let buttonclass:string;
    switch (true) {
      case (this.dateDiff(remember) > 0):
        buttonclass = "alert alert-danger alert-sm";
        break
      case ((this.dateDiff(remember) >= -5) && (this.dateDiff(remember) <= 0)):
        buttonclass = "alert alert-warning alert-sm";
        break
      default:
        buttonclass = ""
        break
    }

    return buttonclass;
  }
}
